type RatingLabel = 'excellent' | 'great' | 'average' | 'poor' | 'bad' | 'none'

export const ratingLabelByScore = (score: number): RatingLabel => {
  if (score >= 4.2) {
    return 'excellent'
  }
  if (score >= 3.7) {
    return 'great'
  }
  if (score >= 3) {
    return 'average'
  }
  if (score >= 2) {
    return 'poor'
  }
  if (score >= 1) {
    return 'bad'
  }
  return 'none'
}

export const RATING_COPY_BY_LABEL: Record<RatingLabel, string> = {
  excellent: 'Hervorragend',
  great: 'Gut',
  average: 'Akzeptabel',
  poor: 'Mangelhaft',
  bad: 'Ungenügend',
  none: 'Keine'
}
